import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'
import ComposerStore from '~publish/legacy/composer/composer/stores/ComposerStore'

/**
 * The Flux draft that holds the channel-less content. Normally the omni draft,
 * but in preview mode with a single channel selected the user composes on that
 * channel's draft (the editor switches off omni), so source it from there.
 * With more than one channel selected there is no single channel-less body.
 */
export function getChannelLessSourceDraft(): Draft | undefined {
  const omniDraft = ComposerStore.getDraft('omni')
  if (omniDraft && !omniDraft.isEmpty()) return omniDraft

  const enabledDrafts = ComposerStore.getEnabledDrafts()
  if (enabledDrafts.length === 1) return enabledDrafts[0]

  return omniDraft
}
